import React, { useState, useEffect } from 'react';
import './summaryhospitalization.css';
import Administration from './administration';
import Procedure from './procedure';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../service/caller';
import { useNavigate } from 'react-router-dom';


// FRAME 10 – Patient Dossier (updated & re-organized)
function PatientDossier({ onNext, patientData, onBack, onSave }) {
    const [admissionData, setAdmission] = useState(null);
    const [medicationData, setMedicationData] = useState([]);

    useEffect(() => {
        const fetchAdmissionData = async () => {
            if (!patientData?._id) return;
            try {
                const response = await api.get(`api/rooms/hospitalization/details/${patientData._id}`);
                setAdmission(response.data.data);
                console.log('med', response.data.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };

        fetchAdmissionData();
    }, [patientData?._id]);

    if (!patientData) {
        return (
            <div className="frame">
                <h1 className="header">Aucun dossier patient sélectionné</h1>
                <button className="btn back" onClick={onBack}>Retour</button>
            </div>
        );
    }
    if (!admissionData) {
        return <p>Chargement...</p>;
    }

    const { admission, patient, room, dailyCheckIns, treatmentPlan } = admissionData;

    const formatDate = (dateString) => new Date(dateString).toLocaleDateString();
    const stayDays = patientData?.admissionDate
        ? Math.max(1, Math.ceil(
            (new Date() - new Date(patientData.admissionDate)) / (1000 * 60 * 60 * 24)
        ))
        : 1;

    const handleMedicationChange = (medicationRows) => {
        setMedicationData(medicationRows);
    };

    return (
        <>
            <ToastContainer />

            <div className="pmd-container">
      <div className="pmd-card">
        <div className="pmd-header-actions">
          <button className="pmd-btn pmd-btn-back" onClick={() => onNext(1)}>
            <span className="pmd-btn-icon">←</span>
            <span className="pmd-btn-text">Retour</span>
          </button>

          <button className="pmd-btn pmd-btn-billing" onClick={() => onNext(6)}>
            <span className="pmd-btn-text">View billing informations</span>
          </button>
        </div>

        {/* Section Patient Details */}
        <div className="pmd-section">
          <div className="pmd-section-header">
            <span className="pmd-indicator"></span>
            <h3 className="pmd-section-title">Patient Details</h3>
          </div>

          <div className="pmd-details-grid">
            <div className="pmd-detail-item">
              <label className="pmd-label">Nom :</label>
              <p className="pmd-value">{patientData.patientId?.lastname}</p>
            </div>
            <div className="pmd-detail-item">
              <label className="pmd-label">Prénom :</label>
              <p className="pmd-value">{patientData.patientId?.firstname}</p>
            </div>
            <div className="pmd-detail-item">
              <label className="pmd-label">Date of birth :</label>
              <p className="pmd-value">{formatDate(patientData.patientId?.age)}</p>
            </div>
            <div className="pmd-detail-item">
              <label className="pmd-label">Address :</label>
              <p className="pmd-value">{patientData.patientId?.address}</p>
            </div>
            <div className="pmd-detail-item">
              <label className="pmd-label">Gender :</label>
              <p className="pmd-value">{patientData.patientId?.gender}</p>
            </div>
          </div>
        </div>

        {/* Section Room Assignment */}
        <div className="pmd-section pmd-room-section">
          <div className="pmd-room-grid">
            <div className="pmd-detail-item">
              <label className="pmd-label">Room Assigned</label>
              <p className="pmd-value pmd-room-number">{patientData.roomId?.roomNumber}</p>
            </div>
            <div className="pmd-detail-item">
              <label className="pmd-label">Bed Assigned</label>
              <p className="pmd-value pmd-bed-number">
                <span className="pmd-bed-icon">🛏️</span> {patientData.bedNumber}
              </p>
            </div>
            <div className="pmd-detail-item">
              <label className="pmd-label">Assign Date</label>
              <p className="pmd-value">{formatDate(patientData.admissionDate)}</p>
            </div>
          </div>
        </div>

        {/* Section Hospitalization Details */}
        <div className="pmd-section">
          <div className="pmd-section-header">
            <span className="pmd-indicator"></span>
            <h3 className="pmd-section-title">About hospitalisation :</h3>
          </div>

          <div className="pmd-hospitalization-details">
            <div className="pmd-detail-row">
              <span className="pmd-detail-label">Duration : </span>
              <span className="pmd-detail-value">{stayDays} day(s)</span>
            </div>
            <div className="pmd-detail-row">
              <span className="pmd-detail-label">Note: </span>
              <span className="pmd-detail-value">{patientData.note}</span>
            </div>
          </div>
        </div>

        {/* Section Treatment */}
        {treatmentPlan && (
          <div className="pmd-section">
            <div className="pmd-section-header">
              <span className="pmd-indicator"></span>
              <h3 className="pmd-section-title">Treatment</h3>
            </div>
            
            <div className="pmd-treatment-details">
              <div className="pmd-detail-row">
                <span className="pmd-detail-label">Status : </span>
                <span className="pmd-detail-value">{treatmentPlan?.status}</span>
              </div>
              <div className="pmd-detail-row">
                <span className="pmd-detail-label">Note : </span>
                <span className="pmd-detail-value">{treatmentPlan?.notes}</span>
              </div>
              <div className="pmd-detail-row">
                <span className="pmd-detail-label">Follow Up Date : </span>
                <span className="pmd-detail-value">{formatDate(treatmentPlan?.followUpDate)}</span>
              </div>
            </div>

            {/* Medication Section */}
            <div className="pmd-subsection">
              <h4 className="pmd-subsection-title">Medication</h4>
              <Administration 
                patientId={{ patientId: { _id: patientData.patientId?._id } }}
                onMedicationChange={handleMedicationChange}
                medicationRows={treatmentPlan?.medications || []}
              />
            </div>

            {/* Procedure Section */}
            <div className="pmd-subsection">
              <h4 className="pmd-subsection-title">Procedure</h4>
              <Procedure
                patientId={{ patientId: { _id: patientData.patientId?._id } }}
                onMedicationChange={handleMedicationChange}
                medicationRows={treatmentPlan?.procedures || []}
              />
            </div>
          </div>
        )}
      </div>
      
      
    </div>
        </>

    );
}

export default PatientDossier;
